import { z } from 'zod';
export const offerRequestReportStatusSchema = z.enum([
    'Open',
    'WorkInProgress',
    'WorkDone',
    'UserNotAvailable',
    'UserLost',
    'UserDeclined',
    'TestRequest',
    'AppointmentScheduled',
    'OfferPending',
    'PartnerUnreachable',
    'RequestRejected',
]);
export const OfferRequestReportStatus = offerRequestReportStatusSchema.enum;
export const settableOfferRequestReportStatusSchema = offerRequestReportStatusSchema.extract([
    'Open',
    'OfferPending',
    'AppointmentScheduled',
    'WorkInProgress',
    'WorkDone',
    'UserNotAvailable',
    'UserLost',
    'UserDeclined',
]);
